/**
 * SLA clock state for display (Q-026a).
 *
 * "Approaching" comes from the backend: the SLA job stamps
 * `sla_{response,resolution}_warning_sent_at` once a clock passes the contract's
 * warning threshold (default 75% of the business-hours window). The UI used to
 * recompute it from the due date alone and never reached the state.
 */
export type SlaState = 'onTime' | 'approaching' | 'breached' | 'responded' | 'closed';

export interface SlaStateInput {
  dueAt?: string | null;
  breached?: boolean;
  responded?: boolean;
  isClosed?: boolean;
  warningSentAt?: string | null;
  now?: number;
}

export function getSlaState({
  dueAt,
  breached,
  responded = false,
  isClosed = false,
  warningSentAt,
  now = Date.now(),
}: SlaStateInput): SlaState {
  if (isClosed) return 'closed';
  if (responded) return 'responded';
  if (breached) return 'breached';
  if (!dueAt) return 'onTime';
  if (new Date(dueAt).getTime() <= now) return 'breached';
  if (warningSentAt) return 'approaching';
  return 'onTime';
}
